import { responses } from "../../../mocks/trendData";

const toneMap: Record<string, string> = {
  回应中: "bg-primary-100 text-primary-700",
  待回应: "bg-background-200 text-foreground-600",
  进行中: "bg-accent-100 text-accent-800",
  独立观点: "bg-secondary-100 text-secondary-800",
};

export default function Responses() {
  return (
    <section id="responses" className="bg-background-50 py-10 md:py-14">
      <div className="container-x grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="section-kicker">各方回应一览</span>
          <h2 className="mt-3 font-heading text-xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
            口径可能不一致，但都摆在明面
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            我们不预判谁绝对正确，而是把品牌、当事人、监管与第三方说法并列呈现并注明时间，
            让你结合完整时间线自行判断。后续有正式结论会第一时间同步。
          </p>
          <div className="mt-6 flex items-center gap-4 rounded-lg border border-accent-200 bg-accent-100/70 p-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-megaphone-line" aria-hidden="true"></i>
            </span>
            <p className="text-sm text-accent-900">
              关键方仍"待回应"的口径，是我们追踪更新的第一优先级。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {responses.map((r) => (
              <article
                key={r.source}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 md:p-5"
              >
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h3 className="text-sm font-bold text-foreground-950">{r.source}</h3>
                  <span className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-bold ${toneMap[r.tone]}`}>
                    {r.tone}
                  </span>
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{r.text}</p>
                <span className="mt-4 flex items-center gap-1.5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {r.date}
                </span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}